export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('rss_widget', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'Rss',
          tagName: 'div',
          // Problème 6 : l'URL par défaut pointait vers un widget FeedWind
          // (feed.mikle.com/widget/v2/16484/) dont le compte est hors quota —
          // il répond « You have exceeded the widget limit », donc tout bloc RSS
          // fraîchement déposé affichait une erreur. On part désormais d'un bloc
          // vide invitant à saisir l'URL du widget.
          src: '',
          width: '320',
          height: '400',
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1
            },
            {
              type: 'number',

              label: 'width',
              name: 'width',
              changeProp: 1
            },
            {
              type: 'number',
              label: 'height',
              name: 'height',
              changeProp: 1
            }
          ]
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
          this.listenTo(this, 'change:width ', this.updateWidth);
          this.listenTo(this, 'change:height ', this.updateHeight);
        },
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') == 'rss_widget'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          this.view.getIframe().src = this.createUri();
        },
        createUri() {
          // this.updateWidth();
          // this.updateHeight();
          return this.get('src');
        },
        updateWidth() {
          this.view.getIframe().width = this.get('width');
          this.view.getIframe().parentNode.style.width = this.get('width');
        },
        updateHeight() {
          this.view.getIframe().height = this.get('height');
          this.view.getIframe().parentNode.style.height = this.get('height');
        }
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName == 'div') {
            result = { type: 'rss_widget' };
          }
          return result;
        }
      }
    ),
    view: defaultView.extend({
      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          // Sans src on laisse l'iframe vide plutôt que de recharger l'éditeur
          // lui-même (src="" est résolu comme l'URL de la page courante).
          var src = this.model.createUri();
          if (src) ifrm.src = src;
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style.border = 'none;';
          ifrm.style.overflow = 'scroll';
          ifrm.scrolling = 'yes';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';
          ifrm.setAttribute('data-gjs-type', 'rss_widget_iframe');
          this.iframe = ifrm;
        }
        return this.iframe;
      },

      render(...args) {
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('IFRAME').length == 0) {
          this.el.appendChild(this.getIframe());
        }
        return this;
      }
    })
  });
};



// WEBPACK FOOTER //
// ./src/plugins/rss/components.js